import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  FinancialAccountBalanceSummary,
  type FinancialAccountBalanceSummaryConstructor,
} from './FinancialAccountBalanceSummary'

export const FinancialAccountBalanceSummaryConstructorFactory =
  Factory.Sync.makeFactory<FinancialAccountBalanceSummaryConstructor>({
    totalAmount: Factory.each(() => faker.finance.amount()),
    availableAmount: Factory.each(() => faker.finance.amount()),
    allocatedAmount: Factory.each(() => faker.finance.amount()),
    amountAllocatedToSpendingCards: Factory.each(() => faker.finance.amount()),
    amountAllocatedToBillPayments: Factory.each(() => faker.finance.amount()),
    currency: CurrencyNames.USD,
    isInsufficient: false,
  })

export const FinancialAccountBalanceSummaryFactory = EntityFactory(
  FinancialAccountBalanceSummary,
  FinancialAccountBalanceSummaryConstructorFactory
)
